import { clickAddToBasketAction } from 'utils';

export default function useAddToCart() {
    return clickAddToBasketAction() || (() => {});
}
